import { handleActions, combineActions } from 'redux-actions'
import {
  updateContentForms,
  addContentForm,
  removeContentForm,
  updateForm,
  updateContentForm,
  resetFormsState,
} from '../actions'
import { ContentForm } from '../types'

const contentForms = handleActions<ContentForm[], any>(
  {
    [updateContentForms.toString()](state, action) {
      return [...action.payload]
    },
    [addContentForm.toString()](state, action) {
      return [...state, action.payload]
    },
    [removeContentForm.toString()](state, action) {
      const index = state.findIndex((contentForm) => contentForm.FormId === action.payload)
      if (index >= 0) {
        state.splice(index, 1)
      }
      return [...state]
    },
    [combineActions(updateForm, updateContentForm).toString()](state, action) {
      return state.map((form) => {
        if (form.FormId === action.payload.FormId) {
          return { ...form, ...action.payload }
        }
        return form
      })
    },
    [resetFormsState.toString()](state, action) {
      return []
    },
  },
  []
)

export default contentForms
